import { Injectable } from '@angular/core';
import {  HttpGeneralService } from '../../../../shared';
import { CONFIG } from '../../../../shared/config';
let regPatVisitUrl = CONFIG.baseUrls.regPatVisit;

@Injectable()
export class VisitsHistoryService {
    constructor(private _httpGeneralService: HttpGeneralService) { }

    getVisitsHistory(outPatientParms: any ) {
        return this._httpGeneralService.search(outPatientParms, `${regPatVisitUrl}`);
    }

    
}
